import React from 'react'

import classes from './PokemonItems.module.css';
import { Link } from 'react-router-dom';
import { css, cx } from '@emotion/css';

import { ButtonDanger } from '../../components/Button/Button';

//Context
// import MySavedDataContext from '../../store/MySavedData-context';

const PokemonItems = (props) => {

    const ownedBorder = css`
        border: 5px solid green;
        box-sizing:border-box;
    `

    const ownedText = css`
        font-weight:bold;
        color:green;
        text-shadow: 0px 2px 10px green;
    `

    // if (props.mySavedData) {
    //     console.log('SAVED DATAas');
    //     console.log(props.mySavedData.pokemonList);
    // }

    return (

        <div className={classes.pokemonListContainer}>

            {props.pokemonList.pokemonList.map(pokemon => {
                let itemUrl = '';
                let releasePokemonControl = '';

                if (pokemon.ownedPokemonUUID) { //is this myPokemon Page?
                    itemUrl = `/mypokemon/${pokemon.ownedPokemonUUID}`; //adjust link based on the usage
                    releasePokemonControl = (
                        // <button
                        //     className={css`
                        //     padding: 10px 11px;
                        //     background-color: #b21919;
                        //     color: white;
                        //     border-radius: 4px;
                        //     border: 0px;
                        //     margin: 10px;
                        //     cursor:pointer;
                        //     &:hover{
                        //         background-color:#ff5200;
                        //     }
                        //     `}
                        //     onClick={() => props.releaseMyPokemon(pokemon.ownedPokemonUUID)}>Release
                        // </button>

                        <ButtonDanger className={css`margin:10px 15px 5px 10px !important;`} onClick={() => props.releaseMyPokemon(pokemon.ownedPokemonUUID)}>
                            Release
                        </ButtonDanger>
                    );
                } else { //must be pokemon detail (for now...)
                    itemUrl = `/pokemondetail/${pokemon.name}`; //adjust link based on the usage
                }


                return (
                    <div className={cx(classes.pokemonItem, pokemon.numberOwned > 0 ? ownedBorder : '')} key={pokemon.id}>
                        {
                            pokemon.ownedPokemonUUID ?
                                <div className={classes.hashID}>
                                    # {pokemon.ownedPokemonUUID}
                                </div> : ''
                        }
                        <Link to={itemUrl}>
                            <div className={classes.pokemonNameLabel}>
                                {pokemon.name}
                            </div>


                            <div className={css`
                                width: 100%;
                                height: 0;
                                padding-bottom: 100%;
                                position: relative;
                            `}>
                                <img
                                    className={cx(classes.pokemonListImageThumb, `
                                    width: 100%;
                                    position: absolute;
                                    `)}
                                    // src={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${(pokemon.url) ? pokemon.url.match(/(?<=\/)[0-9]*(?=\/$)/g) : (pokemon.id)}.png`} alt=""></img>
                                    src={pokemon.image} alt=""></img>
                                {/* i avoid making extra request for each pokemon in the list....., this considered hacky but more efficient to display pokemon preview image, */}
                                {/* if this goes to production. i will play it safe to request per pokemon, get the sprite URL... or request open up the API to provide pokemon image in the list. or maybe re-consult and assure that the URL and .png will never change.. */}



                            </div>

                        </Link>


                        {/* Is Owned Label: */}
                        {typeof pokemon.numberOwned !== 'undefined' ? <div>You Owned <span className={pokemon.numberOwned > 0 ? cx(ownedText) : ''} >{pokemon.numberOwned}</span></div> : ''}

                        {pokemon.nickname ? <small>Nickname: {pokemon.nickname} </small> : ''}

                        {releasePokemonControl}



                    </div>
                )



            }

            )}
        </div>


    )
}



export default PokemonItems

